import { Appointment } from ".";

export enum PickupAndDeliveryState
{
    NotOffered = 0,
    Offered    = 1 << 0,  // 00000001
    Accepted   = 1 << 1,  // 00000010
    Declined   = 1 << 2,  // 00000100
}

export namespace PickupAndDeliveryState
{
    export function toString( stateOrAppointment: PickupAndDeliveryState | Appointment )
    {

        const state = stateOrAppointment instanceof Appointment ? stateOrAppointment.pickupAndDeliveryState : stateOrAppointment;

        // Consumer has been offered PUAD but hasnt accepted or declined
        if( ( state & PickupAndDeliveryState.Offered ) === PickupAndDeliveryState.Offered ) return 'Offered (pending)';

        // Consumer has accepted PUAD or purchased it directly at booking
        if( ( state & PickupAndDeliveryState.Accepted ) === PickupAndDeliveryState.Accepted ) return 'Accepted';

        // Consumer was offered PUAD but has declined it
        if( ( state & PickupAndDeliveryState.Declined ) === PickupAndDeliveryState.Declined ) return 'Declined';

        // Consumer has not been offered PUAD, or has chosen not purchase it at time
        // of booking directly - can still be offered
        return 'Not offered'; 
        
    }
}

